import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getMissionHistoryItem } from "../../../Services/journey";
import { trackEvent } from "../../../Services/amplitude";
import { JourneyBackHeader, JourneySubpageCard, useStandaloneHeader } from "../shared";
import { MISSION_EVENT, historyItemTitles, missionRoutes } from "./evolution";
import { DimensionCards, MissionStatementHero } from "./MissionParts";
import { HISTORY_COPY as C } from "./copy";
import "../style.css";
import "./style.css";

/**
 * One Mission from the History — `/journey/mission/history/:missionId`.
 *
 * `GET /journey/mission/history/{mission_id}`: the statement and its four
 * elements exactly as they were at that time. Read-only: no Edit, no Restore.
 */
function MissionHistoryItem() {
  const { missionId } = useParams();
  useStandaloneHeader();

  const [state, setState] = useState({ loading: true, error: false, item: null });

  const load = useCallback(async () => {
    setState({ loading: true, error: false, item: null });
    try {
      const item = await getMissionHistoryItem(missionId);
      setState({ loading: false, error: false, item });
      trackEvent(MISSION_EVENT.VERSION_VIEWED, { label: item?.label || null });
    } catch (e) {
      console.error("Failed to load the Mission", e);
      setState({ loading: false, error: true, item: null });
    }
  }, [missionId]);

  useEffect(() => {
    load();
  }, [load]);

  const { item } = state;
  const { title, subtitle } = historyItemTitles(item);

  return (
    <div className="journey-page">
      <div className="journey-page__inner">
        <JourneyBackHeader to={missionRoutes.history} title={item ? title : C.title} />
        <JourneySubpageCard>
          {state.loading && <div className="journey-card journey-card--status">{C.loading}</div>}
          {state.error && (
            <div className="journey-card journey-card--status" role="alert">
              <p style={{ margin: "0 0 12px" }}>{C.detailError}</p>
              <button type="button" className="journey-text-btn" onClick={load}>
                {C.retry}
              </button>
            </div>
          )}
          {item && (
            <>
              <MissionStatementHero statement={item.statement} line={subtitle} />
              <DimensionCards dimensions={item.dimensions} />
            </>
          )}
        </JourneySubpageCard>
      </div>
    </div>
  );
}

export default MissionHistoryItem;
